/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ObservableDoubleComponent from './ObservableDoubleComponent';

/** Implementation of [[ObservableComponentBase]] for observing an integer value. */
@cc._decorator.ccclass
export default class ObservableIntComponent extends ObservableDoubleComponent
{
    /**
     * Sets the new value. If the supplied number is not a whole number, it will be rounded to the nearest whole number.
     * @param value The new value.
     */
    public SetValue(value: number): ObservableIntComponent
    {
        super.SetValue(Math.round(value));
        return this;
    }
}
